<template>
  <div
    v-if="showProductTour"
    :class="$style.visibility"
    data-test-id="ProductTourLaunchButton__wrapper"
  >
    <Button
      v-if="isOutline"
      :class="$style.transparent"
      data-test-id="ProductTourLaunchButton__button"
      hasOutline
      :isDisabled="isDisabled"
      :text="$options.buttonLabel"
      type="secondary"
      @click="handleClick"
    />
    <ButtonLink
      v-else
      data-test-id="ProductTourLaunchButton__buttonLink"
      :text="text"
      @click="handleClick"
    />
  </div>
</template>

<script>
import { Button, ButtonLink } from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import { productTourLabels } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

import ProductTourMixin from './ProductTourMixin';

const onboardingModule = 'OnboardingModule';
const buttonTypes = {
  link: 'link',
  outline: 'outline',
};

export default {
  name: 'ProductTourLaunchButton',

  EventHelper,
  Util,
  buttonLabel: productTourLabels.launch,

  components: {
    Button,
    ButtonLink,
  },

  mixins: [ProductTourMixin],

  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: '',
    },

    location: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: 'link',
      validator: (value) => Object.values(buttonTypes).includes(value),
    },
  },

  computed: {
    ...mapState(onboardingModule, [
      'productTourStepIndex',
    ]),

    isOutline() {
      return this.type === buttonTypes.outline;
    },

    showProductTour() {
      return !this.$options.Util.isSmallScreen();
    },

    text() {
      return this.label ? this.label : this.$options.buttonLabel;
    },
  },

  methods: {
    ...mapActions(onboardingModule, [
      'setShowProductTour',
    ]),

    handleClick() {
      this.$options.EventHelper.triggerProductTourLaunchButtonClicked({
        location: this.location,
        step: this.productTourStepIndex,
      });

      if (this.productTourStepIndex > 0) {
        // Start from the last viewed step
        this.setShowProductTour(true);
      } else {
        // otherwise start from beginning modal
        this.openModal();
      }

      this.$emit('click');
    },
  },
};
</script>

<style module scoped>
@value (max-width-large) from '~css/breakpoints.css';

.transparent {
  background: transparent;
}

/* Legacy vue-test-utils - class needs to exist outside of @media */
.visibility {
  display: block;
}

/* Visibility based NavPanel collapse for mobile/tablet */
@media (max-width: max-width-large) {
  .visibility {
    display: none;
  }
}
</style>
